module.exports = __webpack_public_path__ + "img/20200702_172702.f866a517.jpg";